import React from "react";
import InTransitIcon from "../assets/svg/InTransitIcon";
import OrderRequiredIcon from "../assets/svg/OrderRequiredIcon";
import InPharmacyIcon from "../assets/svg/InPharmacyIcon";
import DrugDispensedIcon from "../assets/svg/DrugDispensedIcon";

const Keys = Object.freeze({
  order_required: "order-required",
  in_transit: "in-transit",
  in_pharmacy: "in-pharmacy",
  in_pharmacy_free: "in-pharmacy-free",
  drug_dispensed: "drug-dispensed",
  drug_dispensed_free: "drug-dispensed-free"
});

const Actions = Object.freeze({
  ordered: { key: "ordered", title: (t) => t("statuses.actions.ordered") },
  arrived: { key: "arrived", title: (t) => t("statuses.actions.arrived") },
  dispensed: { key: "dispensed", title: (t) => t("statuses.actions.dispensed") },
  done: { key: "done", title: (t) => t("statuses.actions.done") }
});

const getLastStep = (isFreeDrug) => (isFreeDrug ? Keys.drug_dispensed_free : Keys.in_pharmacy);
const getFirstStep = (isFreeDrug) =>
  isFreeDrug ? Statuses[Keys.order_required].key : Statuses[Keys.drug_dispensed].key;
const TotalSteps = 4;

const Statuses = Object.freeze({
  [Keys.order_required]: {
    key: Keys.order_required,
    nextStatus: () => Keys.in_transit,
    step: (isFreeDrug) => (isFreeDrug ? 1 : 2),
    title: (t) => t("statuses.titles.order_required"),
    action: (t) => Actions.ordered.title(t),
    getLastStep,
    getFirstStep,
    icon: <OrderRequiredIcon />
  },
  [Keys.in_transit]: {
    key: Keys.in_transit,
    nextStatus: (isFreeDrug) => (isFreeDrug ? Keys.in_pharmacy_free : Keys.in_pharmacy),
    step: (isFreeDrug) => (isFreeDrug ? 2 : 3),
    title: (t) => t("statuses.titles.in_transit"),
    action: (t) => Actions.arrived.title(t),
    getLastStep,
    getFirstStep,
    icon: <InTransitIcon />
  },
  [Keys.in_pharmacy]: {
    key: Keys.in_pharmacy,
    nextStatus: (isFreeDrug) => (isFreeDrug ? Keys.drug_dispensed_free : Keys.order_required),
    step: (isFreeDrug) => (isFreeDrug ? 3 : 4),
    title: (t) => t("statuses.titles.in_pharmacy"),
    action: (t, isFreeDrug) => (isFreeDrug ? Actions.dispensed.title(t) : Actions.done.title(t)),
    getLastStep,
    getFirstStep,
    icon: <InPharmacyIcon />
  },
  [Keys.in_pharmacy_free]: {
    key: Keys.in_pharmacy_free,
    nextStatus: (isFreeDrug) => (isFreeDrug ? Keys.drug_dispensed_free : Keys.order_required),
    step: (isFreeDrug) => (isFreeDrug ? 3 : 4),
    title: (t) => t("statuses.titles.in_pharmacy"),
    action: (t, isFreeDrug) => (isFreeDrug ? Actions.dispensed.title(t) : Actions.done.title(t)),
    getLastStep,
    getFirstStep,
    icon: <InPharmacyIcon />
  },
  [Keys.drug_dispensed_free]: {
    key: Keys.drug_dispensed_free,
    nextStatus: (isFreeDrug) => (isFreeDrug ? Keys.order_required : Keys.in_transit),
    step: (isFreeDrug) => (isFreeDrug ? 4 : 2),
    title: (t) => t("statuses.titles.drug_dispensed"),
    action: (t, isFreeDrug) => (isFreeDrug ? Actions.done.title(t) : Actions.dispensed.title(t)),
    getLastStep,
    getFirstStep,
    icon: <DrugDispensedIcon />
  },
  [Keys.drug_dispensed]: {
    key: Keys.drug_dispensed,
    nextStatus: () => Keys.order_required,
    step: (isFreeDrug) => (isFreeDrug ? 4 : 1),
    title: (t) => t("statuses.titles.drug_dispensed"),
    action: (t, isFreeDrug) => (isFreeDrug ? Actions.done.title(t) : Actions.dispensed.title(t)),
    getLastStep,
    getFirstStep,
    icon: <DrugDispensedIcon />
  }
});

export { Statuses, Keys, Actions, getFirstStep, TotalSteps };
